import { Component, OnInit } from '@angular/core';
import { Router } from "@angular/router";
import { InvoicesService } from '../services/invoices.service';
import { Methods } from '../shared/methods';
import { DinamicData, Cell } from '../models/dinamic-data';

@Component({
  selector: 'app-invoices',
  templateUrl: './invoices.component.html',
  styleUrls: ['./invoices.component.css']
})
export class InvoicesComponent implements OnInit {

  public mtds: Methods = new Methods();
  public bulk: Array<number> = [];
  public loading = false;

  public campoBusqueda = '';
  public paginaActual = 1;
  public itemsPorPagina = 10;
  public totalItems = 0;
  public totalPaginas = 1;

  public invoices: DinamicData = new DinamicData(
    ['check', 'Id', 'Client', 'Invoice', 'Client PO', 'SO', 'Date', 'Due Date', 'Paid in Full', 'Currency', 'Amount', 'Paid', 'Due', 'Voided', 'Type', 'Rep', 'Base Amount', 'Base Paid', 'Base Due', 'Actions']
  )

  constructor(
    private _service: InvoicesService,
    private _router: Router,) { }

  ngOnInit() {
    this.getInvoices();
  }

  action(e) {
    console.log(e);

    switch (e.action) {
      case 'Detail':
        this._router.navigate(["/invoices", e.id]);
        break;
      case 'Print':
        // this.openReport(e.id);
        break;
      case 'Remove':

        break;
      default:
        break;
    }
  }

  getInvoices(e = null) {
    this.loading = true;

    this._service.getInvoices(
      e !== null ? e.page : 1,
      e !== null ? e.perPage : 10,
      e !== null ? (this.campoBusqueda = e.search) : (this.campoBusqueda = '')
    ).subscribe(
      r => {
        console.log(r);
        if (r.code === 400) {
          localStorage.clear();
          this._router.navigate(["/pages/lock"]);
        } else if (r.status === "success") {

          this.paginaActual = Number(r.page_actual);
          this.itemsPorPagina = Number(r.items_per_page);
          this.totalItems = Number(r.total_items_count);
          this.totalPaginas = Number(r.total_pages);

          this.invoices.rows = [];
          for (let element of r.data) {
            let actionButtons = [];

            // if (element.internalcomments != '' && element.internalcomments != null) {
            //   actionButtons.push({ icon: 'mode_comment', action: 'Detail', color: 'warning', title: element.internalcomments})
            // }

            actionButtons.push(
              { icon: 'remove_red_eye', action: 'Detail', color: 'info' },
              // { icon: 'print', action: 'Print', color: 'primary' },
              // { icon: 'delete_outline', action: 'Remove', color: 'danger' }
            );
            this.invoices.rows.push (
              [
                new Cell(element.id, {type: 'checkbox'}),
                new Cell(element.id),
                new Cell(element.client ? `${element.client.name} ${element.client.surname}` : '' ),
                new Cell(element.invoicesInvoice),
                new Cell(element.clientPoNumber),
                new Cell(element.so),
                new Cell(element.date !== null && element.date !== '1900-01-00' && element.date !== '' ? this.mtds.getFecha(new Date(element.date), 'MM-dd-yyyy') : ''),
                new Cell(element.duedate !== null && element.duedate !== '1900-01-00' && element.duedate !== '' ? this.mtds.getFecha(new Date(element.duedate), 'MM-dd-yyyy') : ''),
                new Cell(''),
                new Cell(element.currency),
                new Cell(''),
                new Cell(''),
                new Cell(''),
                new Cell(''),
                new Cell(element.type),
                new Cell(element.rep.name + ' ' + element.rep.surname),
                new Cell(''),
                new Cell(''),
                new Cell(''),
                new Cell(actionButtons, {type: 'actions'})
              ]
            );
          }

        }
        this.loading = false;
      },
      (error) => {
        this.loading = false;
        this.mtds.notifyError(error.statusText);
      }
    );
  }

}
